<template>
    <div>
        <div class="br-bottom m-b-5">
            <div class="row row-middle">
                <nav class="nav-tab">
                    <a v-on:click.prevent="switchTimePeriod('today')" v-bind:class="{'nav-item--active': timePeriod === 'today'}" class="nav-item f-s-4 m-r-3 m-l-0 p-l-0" href="#time-period">{{ trans('Today') }}</a>
                    <a v-on:click.prevent="switchTimePeriod('month')" v-bind:class="{'nav-item--active': timePeriod === 'month'}" class="nav-item f-s-4 m-r-3 m-l-3" href="#time-period">{{ trans('This Month') }}</a>
                    <a v-on:click.prevent="switchTimePeriod('year')" v-bind:class="{'nav-item--active': timePeriod === 'year'}" class="nav-item f-s-4 m-r-3 m-l-3" href="#time-period">{{ trans('This Year') }}</a>
                    <a v-on:click.prevent="switchTimePeriod('all-time')" v-bind:class="{'nav-item--active': timePeriod === 'all-time'}" class="nav-item f-s-4 m-r-3 m-l-3" href="#time-period">{{ trans('All Time') }}</a>
                </nav>
                <div v-if="usedCurrencies.length > 1" class="text-right">
                    <reporting-currency-dropdown-menu
                        v-bind:selected-currency="reportingCurrency"
                        v-bind:available-currencies="usedCurrencies"
                    ></reporting-currency-dropdown-menu>
                </div>
            </div>
        </div>
        <div class="dashboard-chart-meta m-b-4">
            <div class="row row-collapse row-middle">
                <div class="column f-s-5">
                    <div class="row row-collapse row-middle">
                        {{ headline }}
                        <help-button v-bind:article-id="82" class="m-l-1 cu-p"></help-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="dashboard-chart-content chart-grid section p-b-5">
            <!-- Member Analytics -->
            <div class="row row-top m-b-4">
                <div class="column p-l-0">
                    <h1 class="f-s-5 m-b-0">{{ trans('Member Analytics') }}</h1>
                </div>
            </div>
            <div class="row row-collapse-indent">
                <metric-item
                    v-for="(metric, index) in memberPeriodData(timePeriod)"
                    v-bind:key="'members-metric-' + index + '-' + timePeriod"
                    v-bind:metric="metric"
                    v-bind:period="timePeriod"
                ></metric-item>
            </div>

            <!-- Checkout Analytics -->
             <div v-if="stats.checkout">
                <div class="row row-top m-b-4">
                    <div class="column p-l-0">
                        <h1 class="f-s-5 m-b-0">{{ trans('Checkout Analytics') }}</h1>
                    </div>
                </div>
                <div class="row row-collapse-indent">
                    <metric-item
                        v-for="(metric, index) in checkoutPeriodData(timePeriod)"
                        v-bind:key="'checkout-metric-' + index + '-' + timePeriod"
                        v-bind:metric="metric"
                        v-bind:period="timePeriod"
                    ></metric-item>
                </div>
             </div>
        </div>
    </div>
</template>
<script>
import MetricItem from './MetricItem.vue';
import ReportingCurrencyDropdownMenu from './ReportingCurrencyDropdownMenu.vue';

export default {
    components: {
        MetricItem,
        ReportingCurrencyDropdownMenu
    },
    props: {
        stats: {
            type: Object
        },
        reportingCurrency: {
            type: String
        },
        usedCurrencies: {
            type: Array
        }
    },
    data() {
        return {
            loading: false,
            timePeriod: 'today',
            memberStats: {'today': this.stats.member},
            checkoutStats: {'today': this.stats.checkout},
        }
    },
    computed: {
        headline() {
            var today = new Date();
            switch (this.timePeriod) {
                case 'today':
                    return this.trans("Today's Overview ") + today.toLocaleDateString(window.Kourses.locale, {
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric'
                    });
                case 'month':
                    return this.trans("Month's Overview ") + today.toLocaleDateString(window.Kourses.locale, {
                        month: 'short',
                        year: 'numeric'
                    });
                case 'year':
                    return this.trans("Year's Overview ") + today.toLocaleDateString(window.Kourses.locale, {
                        year: 'numeric'
                    });
                case 'all-time':
                    return this.trans("All Time Overview");
            }
        },
        previousPeriodLabel() {
            switch (this.timePeriod) {
                case 'today':
                    return this.trans('yesterday');
                case 'month':
                    return this.trans('last month');
                case 'year':
                    return this.trans('last year');
            }
        },
    },
    methods: {
        switchTimePeriod(period) {
            if (this.memberStats[period] === undefined) {
                this.loading = true;

                window.axios.get(window.Kourses.apiBaseUrl + '/dashboard/stats/' + period)
                    .then(response => {
                        this.memberStats[period] = response.data.member;
                        this.checkoutStats[period] = response.data.checkout;
                        this.loading = false;
                        this.timePeriod = period;
                    });
            } else {
                this.timePeriod = period;
            }
        },
        memberPeriodData(period) {
            return this.memberStats[period] || [];
        },
        checkoutPeriodData(period) {
            return this.checkoutStats[period] || [];
        }
    }
}
</script>